import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import CampaignIcon from '@mui/icons-material/Campaign';
import Badge from '@mui/material/Badge';
import IconButton from '@mui/material/IconButton';
import { ErrorBoundary } from '@sentry/react';

import HandleTriggerAlarmForPlantPopup from '../PlantAlarmTrigger/components/plantAlarmTriggerPopup';

interface PlantAlarmTriggerControlProps {
  readonly canOpen: boolean;
}

export const PlantAlarmTriggerControl = ({ canOpen }: PlantAlarmTriggerControlProps): JSX.Element => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  return (
    <>
      {canOpen && (
        <IconButton
          aria-label={t('header.showPlantAlarmTrigger', 'show Plant Alarm Trigger')}
          aria-haspopup="dialog"
          color="inherit"
          onClick={() => setOpen(true)}
        >
          <Badge max={99} color="error">
            <CampaignIcon />
          </Badge>
        </IconButton>
      )}
      {open && (
        <ErrorBoundary>
          <HandleTriggerAlarmForPlantPopup open handleClose={() => setOpen(false)} />
        </ErrorBoundary>
      )}
    </>
  );
};
